"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DATETIMEPICKERINLINE_CONFIG = {
    DateFormat: 'MMM D, YYYY',
    TimeFormat: 'h:mm a',
    Readonly: false
};
